export default __webpack_public_path__ + "static/N0131-f64640a9acbf458fd07967e21673f055.png";